import { render, staticRenderFns } from "./PuzzleList.vue?vue&type=template&id=a0e5e706&"
import script from "./PuzzleList.vue?vue&type=script&lang=js&"
export * from "./PuzzleList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports